export default {
  /**
   * This function is called while looping through dutyActivities to create a list of duty activities whose activities
   * might merge several items. Each item can have child objects within the children attribute.
   *
   * shouldMergeDutyActivity must check what happens with the currentDutyActivity. However the function does not
   * manipulate data but needs to return an advice what should be done (described in return)
   *
   * @param {Object} MeinDienst module configuration object
   * @param {Object} accumulator The duty activity which may accumulate other duty activities
   * @param {Object} currentDutyActivity The current duty activity when looping through all activities
   * @param {Array} dutyActivities all duty activities
   * @param {Number} currentIndex the current index when looping through the duty activities
   * @returns string one of the following
   *                 new: that is the current item is used right away
   *                 mergeToAccumulator: the next two items are merged with the current item
   */
  shouldMergeDutyActivity: ({ moduleConfig, accumulator, currentDutyActivity, dutyActivities, currentIndex }) => {
    if (!accumulator) {
      return 'mergeToAccumulator';
    }
    return 'new';
  },

  /**
   * Returns the first relevant activity within the given dutyActivities array.
   * The default behavior is to return the first element with a defined blockcode. However this might be specialized by each tenant.
   * @param {Object} MeinDienst module configuration object
   * @param {Array} dutyActivities Array of sorted activities (by time) belonging to one duty
   * @returns dutyActivity declared to be the first relevant
   */
  getFirstActivity: ({ moduleConfig, dutyActivities }) => {
    return dutyActivities.find((a) => !!a.blockcode);
  },

  /**
   * Returns the last duty activity in the sorted list of duty activities.
   * Defaults to return the last activity within the array of activities
   * @param {Object} MeinDienst module configuration object
   * @param {*} dutyActivities
   * @returns the last relevant duty activity
   */
  getLastActivity: ({ moduleConfig, dutyActivities }) => {
    return dutyActivities[dutyActivities.length - 1];
  },

  /**
   * Returns the track selection applied when the user chooses a duty activity.
   * Only set properties are getting used. Therefore the default case does not set the track property.
   * @param dutyActivity
   * @returns {{startToMinutesAfterMidnight, endToMinutesAfterMidnight, line,track, blockcode}}
   */
  getTrackSpecificationFromDutyActivity: (dutyActivity) => {
    return {
      line: dutyActivity.line,
      blockcode: dutyActivity.blockcode,
      startToMinutesAfterMidnight: dutyActivity.fromMinutesAfterMidnight,
      endToMinutesAfterMidnight: dutyActivity.toMinutesAfterMidnight,
    };
    /**
     *  // this.track = dutyActivity.blockcode; // bei LVB steht der Umlauf im Blockcode, welcher für die Filterung verwendet werden muss
     *       this.line = dutyActivity.line;
     *       this.blockcode = dutyActivity.blockcode;
     *       this.startToMinutesAfterMidnight = dutyActivity.fromMinutesAfterMidnight;
     *       this.endToMinutesAfterMidnight = dutyActivity.toMinutesAfterMidnight;
     *
     *       let { dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight } = this;
     *
     */
  },

  /**
   * Pre process the duty activities to apply some filters or sorting
   * @param moduleConfig
   * @param dutyActivities
   * @returns dutyActivities
   */
  preProcessDutyActivities: (moduleConfig, dutyActivities) => {
    return dutyActivities;
  },
};
